
import React from "react";

interface RequiredFieldLabelProps {
  label: string;
}

export const RequiredFieldLabel: React.FC<RequiredFieldLabelProps> = ({ label }) => {
  return (
    <div className="flex items-center gap-1">
      <span>{label}</span>
      <span className="text-red-500">*</span>
    </div>
  );
};
